module.exports = __webpack_public_path__ + "static/img/sign_app_def.79cf1d45.png";